module.exports = __webpack_public_path__ + "img/imgHome.8f466ea5.png";